var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAlert = function SvgIconAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23.074,
    viewBox: "0 0 25 23.074",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-warning",
    "data-name": "Icon ionic-ios-warning",
    d: "M14.245,5.455,3.6,24.876a1.826,1.826,0,0,0,1.628,2.7h21.29a1.83,1.83,0,0,0,1.628-2.7L17.5,5.455A1.865,1.865,0,0,0,14.245,5.455Zm2.686,8.058-.216,7.331H15.032l-.216-7.331ZM15.874,24.834a1.106,1.106,0,1,1,1.148-1.106A1.116,1.116,0,0,1,15.874,24.834Z",
    transform: "translate(-3.375 -4.5)",
    fill: "#f6c866"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-alert.d4fb58c3.svg";
export { ForwardRef as ReactComponent };